export default function initializeForm (formObject) {
  // Initialize all form fields
  Object.keys(formObject).forEach(field => {
    if (formObject[field].rtEditor) {
      if (document.getElementById(formObject[field].ref)) {
        const RTEditor = document.getElementById(formObject[field].ref)
        const element = RTEditor.getElementsByClassName('ql-editor')
        element[0].innerHTML = ''
      }
    }
    formObject[field].error = ''
    formObject[field].content = ''
    if (field === 'folder') {
      formObject[field].content = false
    }
  })
}
